<template>
  <v-container>
    <v-row>
      <v-col md="6" sm="12">
        <router-link :to="{ name: 'cambiarPassword' }">
          <v-img max-width="350" src="@/assets/cambiarPassword.png"></v-img>
        </router-link>
      </v-col>
      <v-col md="6" sm="12">
        <router-link :to="{ name: 'descargarBoletaPago' }">
          <v-img max-width="350" src="@/assets/descargarBoletaPago.png"></v-img>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Principal",

  data: () => ({}),
  methods: {},
};
</script>


